export default {
      id: "build-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#build-usage",
      toString: function () {
        return this.url;
      }
    }